<template>
	<div>
		<loading v-if="!loaded" />
		<div v-if="loaded">
			<div class="page-title"><span>{{$store.state.lang.text.promotion[$store.state.lang.language]}}</span></div>
				<div class="md-layout" style="margin-top: 15px;">
					<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
						<h4 style="margin: 0px 0 15px">ការផ្តល់ជូនសម្រាប់សមាជិកថ្មី</h4>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-25" v-for="promotion in new_member_deposit">
						<div class="promotion-container">
							<div class="promotion-image-cover">
								<img :src="promotion.image">
							</div>
							<div class="promotion-title">
								<span>{{promotion.text}}</span>
							</div>
							<div class="promotion-button-container">
								<div class="promotion-button claim" @click="claim(promotion)" v-if="checkEligible(promotion.id)">ស្នើសុំ</div>
								<div class="promotion-button term" @click="openTerm(promotion)">មើលលម្អិត</div>
							</div>
						</div>
					</div>

					<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
						<h4 style="margin: 20px 0 15px">ការផ្តល់ជូនពិសេសៗសម្រាប់សមាជិកទូទៅ</h4>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-25" v-for="promotion in special_promotion">
						<div class="promotion-container">
							<div class="promotion-image-cover">
								<img :src="promotion.image">
							</div>
							<div class="promotion-title">
								<span>{{promotion.text}}</span>
							</div>
							<div class="promotion-button-container">
								<div class="promotion-button claim" @click="claim(promotion)" v-if="checkEligible(promotion.id) && promotion.id != 10">ស្នើសុំ</div>
								<div class="promotion-button term" @click="openTerm(promotion)">មើលលម្អិត</div>
							</div>
						</div>
					</div>

					<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
						<h4 style="margin: 20px 0 15px">ការណែនាំមិត្ត និងបង្វិលប្រចាំសប្តាហ៍</h4>
					</div>
					<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-25" v-for="promotion in daily_return">
						<div class="promotion-container">
							<div class="promotion-image-cover">
								<img :src="promotion.image">
							</div>
							<div class="promotion-title">
								<span>{{promotion.text}}</span>
							</div>
							<div class="promotion-button-container">
								<div class="promotion-button term" @click="openTerm(promotion)">មើលលម្អិត</div>
							</div>
						</div>
					</div>

				</div>
				<div class="promotion-modal" v-if="showTerm">
					<div class="promotion-term-container">
						<div class="promotion-term-header">
							<div class="title" style="width: 100%"><h4>{{termTitle}}</h4></div>
							<div class="button" style="padding: 0 10px;color: red; font-size: 24px; cursor: pointer;" @click="close()">×</div>
						</div>
						<div class="promotion-term-content">
							<p v-if="termId == 1">
								<ol>
									<li>អតិថិជនថ្មីអាចស្នើសុំបាននៅពេលបានធ្វើការដាក់ប្រាក់ចាប់ពី $10 ឡើងទៅ</li>
									<li>ការផ្តល់ជូននេះអាចធ្វើការស្នើសុំបានតែម្តងគត់ក្នុងមួយគណនី</li>
									<li>ទឹកប្រាក់នេះអាចធ្វើការដាក់បញ្ចូលទៅកាន់គណនី កីឡា E-កីឡា កាស៊ីណូ ឡូតូ បាញ់ត្រី ស្លត និងជល់មាន់</li>
									<li>អតិថិជនតម្រូវអោយភ្នាល់វិលជុំចំនួន $360 ឡើងទៅទើបអាចដកប្រាក់បាន</li>
								</ol>
							</p>
							<p v-if="termId == 2">
								<ol>
									<li>អតិថិជនថ្មីអាចស្នើសុំបាននៅពេលបានធ្វើការដាក់ប្រាក់ចាប់ពី $10 ឡើងទៅ</li>
									<li>ការផ្តល់ជូននេះអាចធ្វើការស្នើសុំបានតែម្តងគត់ក្នុងមួយគណនី</li>
									<li>អតិថិជនអាចបញ្ចូលចំនួនទឹកប្រាក់ដែលចង់ដាក់ផ្ទេរទៅកាន់គណនី កីឡា E-កីឡា កាស៊ីណូ ឡូតូ បាញ់ត្រី ស្លត និងជល់មាន់</li>
									<li>អតិថិជនតម្រូវអោយភ្នាល់វិលជុំសរុប ចំនួនដាក់ប្រាក់ x 22ដង ទើបអាចដកប្រាក់</li>
								</ol>
								ឧទាហរណ៍៖ ផ្ទេរ $10 ទៅកាន់គណនីកាស៊ីណូ។ ទឹកប្រាក់ទទួលបានគឺ $20។ ដើម្បីដកប្រាក់គឺតម្រូវអោយអតិថិជនភ្នាល់វិលជុំចំនួន $20 x 22 ដង = $440 ទើបអាចដកប្រាក់បាន
							</p>
							<p v-if="termId == 3">
								អតិថិជនអាចធ្វើការចែករំលែក Link ណែនាំមិត្តភ័ក្តិផ្សេងទៀត។ នៅពេលមិត្តភ័ក្តិថ្មីបានចុះឈ្មោះ បានដាក់ប្រាក់ចាប់ពី $10 និងបានភ្នាល់វិលជុំចាប់ពី $10 ឡើងទៅ។ អតិថិជនអ្នកណែនាំនោះនឹងទទួលបាន $1 ភ្លាមៗទៅកាន់គណនីគោល
							</p>
							<p v-if="termId == 4">
								<ol>
									<li>អតិថិជនថ្មីអាចស្នើសុំបាននៅពេលបានធ្វើការដាក់ប្រាក់ចាប់ពី $10 ឡើងទៅ</li>
									<li>ការផ្តល់ជូននេះអាចធ្វើការស្នើសុំបានជារៀងរាល់ថ្ងៃ</li>
									<li>អតិថិជនអាចបញ្ចូលចំនួនទឹកប្រាក់ដែលចង់ដាក់ផ្ទេរទៅកាន់គណនី កីឡា E-កីឡា កាស៊ីណូ ឡូតូ បាញ់ត្រី ស្លត និងជល់មាន់</li>
									<li>អតិថិជនតម្រូវអោយភ្នាល់វិលជុំសរុប ចំនួនដាក់ប្រាក់ x 9ដង ទើបអាចដកប្រាក់</li>
								</ol>
								ឧទាហរណ៍៖ ផ្ឬេរ $10 ទៅកាន់គណនីកាស៊ីណូ។ ទឹកប្រាក់ទទួលបានគឺ $11។ ដើម្បីដកប្រាក់គឺតម្រូវអោយអតិថិជនភ្នាល់វិលជុំចំនួន $11 x 9 ដង = $99 ទើបអាចដកប្រាក់បាន
							</p>
							<p v-if="termId == 5">
								<ol>
									<li>ការបង្វិលជូនវិញ ប្រព័ន្ធនឹងធ្វើការទូទាត់នៅរៀងរាល់ថ្ងៃអាទិត្យ</li>
									<li>ចំនួនបង្វិល = (ចំនួនភ្នាល់ - ចំនួនឈ្នះ នៃរយៈពេល ៧ថ្ងៃចុងក្រោយ ) x ភាគរយ</li>
									<li>ប្រព័ន្ធនឹងបង្វិលជូនចំពោះ ចំនួនបង្វិលណាដែលធំជាង $1 ប៉ុន្នោះ</li>
								</ol>
							</p>
							<p v-if="termId == 6">
								<ol>
									<li>អតិថិជនថ្មីអាចស្នើសុំបាននៅពេលបានធ្វើការដាក់ប្រាក់ចាប់ពី $20 ឡើងទៅ</li>
									<li>អតិថិជនអាចដាក់ទឹកប្រាក់កាន់គណនីឡូតូប៉ុណ្ណោះ</li>
									<li>អតិថិជនតម្រូវអោយភ្នាល់វិលជុំសរុប ចំនួនដាក់ប្រាក់ x 22ដង ទើបអាចដកប្រាក់</li>
								</ol>
								ឧទាហរណ៍៖ ដាក់ $20 ទៅកាន់គណនីកាស៊ីណូ។ ទឹកប្រាក់ទទួលបានគឺ $50។ ដើម្បីដកប្រាក់គឺតម្រូវអោយអតិថិជនភ្នាល់វិលជុំចំនួន $50 x 22 ដង = $1100 ទើបអាចដកប្រាក់បាន
							</p>
						</div>
					</div>
				</div>

				<div class="apply-promotion-modal" v-if="applyPromotion">
					<div class="apply-promotion-container">
						<div class="apply-promotion-header">
							<div class="title" style="width: 100%"><h4>{{applyPromotionTitle}}</h4></div>
							<div class="button" style="padding: 0 10px;color: red; font-size: 24px; cursor: pointer;" @click="close()">×</div>
						</div>
						<div class="apply-promotion-content">
							<div class="md-layout" v-if="apply.promotion_id == 18">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="form__tabs__wrap">
										<form>
											<div class="create__btn"><a class="cmn--btn" @click="requestPromotion()" style="margin-top: 5px; width: 100%"><span>{{$store.state.lang.text.transfer[$store.state.lang.language]}}</span></a></div>
										</form>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<table>
										<tr>
											<td>ផ្ទេរប្រាក់ចំនួន</td>
											<td style="width: 50px;padding-left: 10px">:</td>
											<td>
												<span v-if="String(apply.amount).length > 0">{{config.moneylify(apply.amount)}}</span>
												<span v-else>--</span>
											</td>
										</tr>
										<tr>
											<td>ទឹកប្រាក់ទទួលបាន</td>
											<td style="width: 50px;padding-left: 10px">:</td>
											<td>
												<span>{{config.moneylify(50)}}</span>
											</td>
										</tr>
									</table>
								</div>
							</div>


							<div class="md-layout" v-if="apply.promotion_id > 2 && apply.promotion_id <= 17">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5 style="font-size: 15px;margin-bottom: 15px">សូមធ្វើការវាយបញ្ចូលទឹកប្រាក់ដែលអ្នកចង់ផ្ទេរដើម្បីទទួលបានការផ្តល់ជូន</h5>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="form__tabs__wrap">
										<form>
											<div class="form__grp"><input type="number" v-model="apply.amount" :placeholder="$store.state.lang.text.transfer_amount[$store.state.lang.language]"></div>
										</form>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="auto-select-container">
										<div class="item-money" @click="add(5)">$5.00</div>
										<div class="item-money" @click="add(10)">$10.00</div>
										<div class="item-money" @click="add(25)">$25.00</div>
										<div class="item-money" @click="addAll()">ទាំងអស់</div>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="form__tabs__wrap">
										<form>
											<div class="create__btn"><a class="cmn--btn" @click="requestPromotion()" style="margin-top: 5px; width: 100%"><span>{{$store.state.lang.text.transfer[$store.state.lang.language]}}</span></a></div>
										</form>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<table>
										<tr>
											<td>ផ្ទេរប្រាក់ចំនួន</td>
											<td style="width: 50px;padding-left: 10px">:</td>
											<td>
												<span v-if="String(apply.amount).length > 0">{{config.moneylify(apply.amount)}}</span>
												<span v-else>--</span>
											</td>
										</tr>
										<tr>
											<td>ទឹកប្រាក់ទទួលបាន</td>
											<td style="width: 50px;padding-left: 10px">:</td>
											<td v-if="apply.promotion_id >= 3 && apply.promotion_id <= 9">
												<span v-if="String(apply.amount).length > 0">{{config.moneylify(apply.amount*2) }}</span>
												<span v-else>--</span>
											</td>
											<td v-if="apply.promotion_id >= 11 && apply.promotion_id <= 17">
												<span v-if="String(apply.amount).length > 0">{{config.moneylify(apply.amount*1.1) }}</span>
												<span v-else>--</span>
											</td>
										</tr>
									</table>
								</div>
							</div>

							<div class="md-layout" v-if="apply.promotion_id == 2">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5 style="font-size: 15px;margin-bottom: 15px">សូមធ្វើការជ្រើសរើសប្រភេទគណនីដើម្បីទទួលបានការផ្តល់ជូន</h5>
								</div>
								<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
									<div class="verification__box" style="padding: 0 !important">
										<div class="attach__wrap">
											 <select v-model="apply.wallet_id">
												  <option value="">សូមជ្រើសរើសគណនី</option>
												  <option value="1">គណនី កីឡា</option>
												  <!-- <option value="2">គណនី E-កីឡា</option> -->
												  <option value="3">គណនី កាស៊ីណូ និងជល់មាន់</option>
												  <option value="4">គណនី ស្លត់</option>
												  <option value="5">គណនី បាញ់ត្រី</option>
												  <option value="6">គណនី ឡូតូ</option>
												  <!-- <option value="7">គណនី Cockfighting</option> -->
											 </select>
										</div>
								  </div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<div class="form__tabs__wrap">
										<form>
											<div class="create__btn"><a class="cmn--btn" @click="requestPromotionFree()" style="margin-top: 5px; width: 100%"><span>{{$store.state.lang.text.confirm[$store.state.lang.language]}}</span></a></div>
										</form>
									</div>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<table>
										<tr>
											<td>ទឹកប្រាក់ទទួលបាន</td>
											<td style="width: 50px;padding-left: 10px">:</td>
											<td>
												<span v-if="String(apply.wallet_id).length > 0">{{config.moneylify(9) }}</span>
												<span v-else>--</span>
											</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getBalance();
			this.getUserPromotion();
		},
		methods: {
			requestPromotionFree() {
				if(String(this.apply.wallet_id).length > 0) {
					this.$store.state.authentication.loading = true;
					let promotion_id = this.apply.promotion_id;
					let wallet_id = this.apply.wallet_id;
					let amount = 9;
					this.close();
					this.$http.post(this.config.api + "/user/authed/promotion/apply", {
						promotion_id: promotion_id,
						amount: amount,
						wallet_id: wallet_id
					}).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							this.$router.push("/account/balance");
						}
					})
				}
			},
			requestPromotion() {
				if(String(this.apply.amount).length > 0 && String(this.apply.promotion_id).length > 0) {
					this.$store.state.authentication.loading = true;

					let promotion_id = this.apply.promotion_id;
					let amount = this.apply.amount;
					let wallet_id = this.apply.wallet_id;
					this.close();
					if(parseFloat(amount) > 0) {
						this.$http.post(this.config.api + "/user/authed/promotion/apply", {
							promotion_id: promotion_id,
							amount: amount,
							wallet_id: wallet_id
						}).then(res => {
							this.$store.state.authentication.loading = false;
							if (res.body.status == 'success') {
								this.$router.push("/account/balance");
							}
						})
					} else {
						this.$notification.notify("សូមបំពេញចំនួនទឹកប្រាក់ឱ្យបានត្រឹមត្រូវ។");
					}
				} else {
					this.$notification.notify("សូមបំពេញឱ្យបានត្រឹមត្រូវ។");
				}
			},
			claim(promotion) {
				if(this.$store.state.authentication.loggedIn) {
					this.$store.state.authentication.loading = true;
					this.$http.post(this.config.api + "/user/authed/promotion/check", {
						promotion_id: promotion.id
					}).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							this.applyPromotion = true;
							this.applyPromotionTitle = promotion.text
							this.apply.promotion_id = promotion.id
							if(this.apply.promotion_id == 18) {
								this.apply.amount = 20;
								this.apply.wallet_id = 6;
							};
						}
					})
				} else {
					this.$router.push("/login");
				}
			},
			openTerm(promotion) {
				this.showTerm = true;
				this.termTitle = promotion.text;
				this.termId = promotion.term;
			},
			getUserPromotion() {
				if(this.$store.state.authentication.loggedIn) {
					this.$http.get(this.config.api + "/user/authed/promotion/get_list").then(res => {
						if (res.body.status == 'success') {
							this.loaded = true;
							this.userPromotionList= res.body.data
						}
					})
				} else {
					this.loaded = true;
				}
			},
			getBalance() {
				if(this.$store.state.authentication.loggedIn) {
					this.$http.get(this.config.api + "/user/authed/user/get_balance").then(res => {
						if (res.body.status == 'success') {
							this.currentBalance = res.body.data.balance
						}
					})
				}
			},
			checkEligible(id) {
				for(let i =0; i< this.userPromotionList.length; i++) {
					if(id == this.userPromotionList[i].promotion_id) {
						return false;
					}
				}
				return true;
			},
			add(amount) {
				amount = parseFloat(amount);

				if(this.apply.amount.length == 0 ){
					this.apply.amount = amount;
				} else {
					if(parseFloat(this.apply.amount) + amount > this.currentBalance) {
						this.apply.amount = parseFloat(this.currentBalance).toFixed(2);
					} else {
						this.apply.amount = parseFloat(this.apply.amount) + amount;
					}
				}
			},
			addAll() {
				this.apply.amount = parseFloat(this.currentBalance).toFixed(2);
			},
			close() {
				this.apply = {
					amount: "",
					promotion_id: "",
					wallet_id: ""
				}
				this.showTerm = false;
				this.applyPromotion = false;
				this.applyPromotionTitle = "";
				this.termTitle = "";
				this.termId = "";
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: false,
				showTerm: false,
				termTitle: "",
				termId: "",
				applyPromotion: false,
				applyPromotionTitle: "",
				userPromotionList: [],
				currentBalance: 0,
				new_member: [
					{id: 19,text: "អតិថិជនថ្មីទទួលបាន $1 ភ្លាមៗ", image: "/promotions/free-1.jpg", term: 1},
					{id: 20, text: "ដាក់ $1 ទទួលបាន $5", image: "/promotions/1-get-5.jpg", term: 2}
				],
				new_member_deposit: [
					{id: 2,text: "អតិថិជនថ្មីទទួលបាន $9 ភ្លាមៗ", image: "/promotions/free-9.jpg", term: 1},
					{id: 3, text: "ប្រាក់បន្ថែម 100% សម្រាប់កីឡា", image: "/promotions/100-sport.jpg", term: 2},
					{id: 4, text: "ប្រាក់បន្ថែម 100% សម្រាប់កីឡានិម្មិត", image: "/promotions/100-esport.jpg", term: 2},
					{id: 5, text: "ប្រាក់បន្ថែម 100% សម្រាប់កាស៊ីណូផ្សាយផ្ទាល់ និងជល់មាន់", image: "/promotions/100-casino-cock.jpg", term: 2},
					{id: 6, text: "ប្រាក់បន្ថែម 100% សម្រាប់ស្លត់ហ្គេម", image: "/promotions/100-slot.jpg", term: 2},
					{id: 7, text: "ប្រាក់បន្ថែម 100% សម្រាប់ហ្គេមបាញ់ត្រី", image: "/promotions/100-fishing.jpg", term: 2},
					{id: 8, text: "ប្រាក់បន្ថែម 100% សម្រាប់ឡូតូ", image: "/promotions/100-keno.jpg", term: 2},
					// {id: 9, bonus: 100, text: "ប្រាក់បន្ថែម 100% សម្រាប់ជល់មាន់", image: "/promotions/100-cock.jpg", term: 2}
				],
				daily_return: [
					{text: "ណែនាំមិត្តភ័ក្តិចុះឈ្មោះ និងដាក់ប្រាក់ទទួលបាន $1 ភ្លាមៗ", image: "/promotions/referral.jpg", term: 3},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់កីឡា 3%", image: "/promotions/return-sport.jpg", term: 5},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់កីឡានិម្មិត 5%", image: "/promotions/return-esport.jpg", term: 5},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់កាស៊ីណូផ្សាយផ្ទាល់ និងជល់មាន់ 5%", image: "/promotions/return-cock.jpg", term: 5},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់ស្លត់ហ្គេម 5%", image: "/promotions/return-slot.jpg", term: 5},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់ហ្គេមបាញ់ត្រី 10%", image: "/promotions/return-fishing.jpg", term: 5},
					{text: "ប្រាក់ទឹកបង្វិលជូនវិញសម្រាប់ឡូតូ 8%", image: "/promotions/return-keno.jpg", term: 5}
				],
				special_promotion: [
					{id: 18, text: "ការផ្តល់ជូន $20 ទទួលបាន $50 សម្រាប់ឡូតូ", image: "/promotions/20-50.jpg", term: 6},
					{id: 11, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កីឡា", image: "/promotions/10-sport.jpg", term: 4},
					{id: 12, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កីឡានិម្មិត", image: "/promotions/10-esport.jpg", term: 4},
					{id: 13, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កាស៊ីណូផ្សាយផ្ទាល់ និងជល់មាន់", image: "/promotions/10-casino-cock.jpg", term: 4},
					{id: 14, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ស្លត់ហ្គេម", image: "/promotions/10-slot.jpg", term: 4},
					{id: 15, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ហ្គេមបាញ់ត្រី", image: "/promotions/10-fishing.jpg", term: 4},
					{id: 16, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ឡូតូ", image: "/promotions/10-keno.jpg", term: 4},
					// {id: 17, bonus: 10, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ជល់មាន់", image: "/promotions/10-cockfighting.jpg", term: 4}
				],
				apply: {
					amount: "",
					promotion_id: "",
					wallet_id: ""
				}
			}
		}
	}
</script>
<style>
	.auto-select-container {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}
	.item-money {
		padding: 7px 7px;
		background-color: rgb(55, 146, 55);
		border-radius: 10px;
		color: #FFF;
		margin: 15px 5px 0px;
		cursor: pointer;
		font-size: 13px
	}
	.promotion-container {
		display: flex;
		flex-direction: column;
		border-radius: 15px;
		border: 1px solid #135F87;
		margin-bottom: 10px;
	}
	.promotion-image-cover img {
		border-top-right-radius: 15px;
		border-top-left-radius: 15px;
	}
	.promotion-title {
		padding: 10px 10px 0;
		text-align: center;
		font-size: 14px;
	}
	.promotion-button-container {
		display: flex;
		flex-direction: row;
		padding: 10px;
		justify-content: center;
	}
	.promotion-button {
		padding: 5px 20px;
		margin: 0 4px;
		border-radius: 10px;
		cursor: pointer;
	}
	.claim {
		background-color: rgb(55, 146, 55);
	}
	.term {
		background-color: #135F87;
	}
	.promotion-modal {
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
		z-index: 99;
		background-color: rgba(0,0,0,0.7);
	}
	.promotion-term-container {
		height: 50%;
		width: 90%;
		max-width: 1000px;
		background-color: white;
		display: flex;
		flex-direction: column;
		border-radius: 15px;
	}
	.promotion-term-header {
		border-bottom: 1px solid #F0F0F0;
		display: flex;
		flex-direction: row;
		padding: 20px;
		color: #333;
	}
	.promotion-term-content {
		height: 100%;
		overflow-y: scroll;
		color: #333;
		padding: 20px;
	}
	.apply-promotion-modal {
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
		z-index: 99999;
		background-color: rgba(0,0,0,0.7);
	}
	.apply-promotion-container {
		height: 50%;
		width: 90%;
		max-width: 400px;
		background-color: white;
		display: flex;
		flex-direction: column;
		border-radius: 15px;
	}
	.apply-promotion-header {
		border-bottom: 1px solid #F0F0F0;
		display: flex;
		flex-direction: row;
		padding: 20px;
		color: #333;
	}
	.apply-promotion-content {
		height: 100%;
		overflow-y: scroll;
		color: #333;
		padding: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Page/Promotions.vue